import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowDiagonal({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowDiagonal</title>
      <path
        d="M5 5L19 19M5 5L10 5M5 5L5 10M19 19V14M19 19H14"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
